// Starter behavior examples surfaced both on the empty Behavior page and inside
// the Add Behavior modal. They cover things the default agent does NOT do on its
// own — business-specific actions and preferences — and are kept generic so they
// fit any business. Anything the user must fill in (links, contacts) is shown as
// a [placeholder] so it's clear it has to be edited into the behavior text.
//
// title/text are stored as i18n KEYS and exposed as lazy getters that resolve via
// the shared i18n instance at read time (render time), so this module-level table
// holds no localized literals and never calls t() at module-eval scope.
import i18n from '../translations';

const EXAMPLE_BEHAVIOR_KEYS = [
  {
    titleKey: 'behavior_ex_offers_title',
    textKey: 'behavior_ex_offers_text',
  },
  {
    titleKey: 'behavior_ex_bookings_title',
    textKey: 'behavior_ex_bookings_text',
  },
  {
    titleKey: 'behavior_ex_callback_title',
    textKey: 'behavior_ex_callback_text',
  },
  {
    titleKey: 'behavior_ex_extras_title',
    textKey: 'behavior_ex_extras_text',
  },
  {
    titleKey: 'behavior_ex_route_title',
    textKey: 'behavior_ex_route_text',
  },
  {
    titleKey: 'behavior_ex_friendly_title',
    textKey: 'behavior_ex_friendly_text',
  },
];

export const EXAMPLE_BEHAVIORS = EXAMPLE_BEHAVIOR_KEYS.map(({ titleKey, textKey }) => ({
  get title() {
    return i18n.t(titleKey);
  },
  get text() {
    return i18n.t(textKey);
  },
}));
